import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import merge from "deepmerge";
import { useRouter } from "next/router";
import { useEffect, useMemo, useReducer } from "react";
const defaultInitialState = {
  nextStep: 1,
  formData: {},
  clearError: true
};
const reducer = (state, action) => {
  const newState = _objectSpread({}, state);
  const {
    formData = {},
    clearError = true
  } = action;
  switch (action.type) {
    case "set":
      return merge(newState, {
        formData,
        clearError
      });
    case "next":
      return merge(newState, {
        nextStep: state.nextStep + 1,
        formData,
        clearError
      });
    case "prev":
      return merge(newState, {
        nextStep: state.nextStep - 1,
        formData,
        clearError
      });
    case "step":
      return merge(newState, {
        nextStep: action.step
      });
    case "reset":
      return defaultInitialState;
    default:
      return state;
  }
};
const defaultOptions = {
  maxStep: 3,
  completeStep: null
};
export function useStep() {
  let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options = _objectSpread(_objectSpread({}, defaultOptions), options);
  const {
    0: state,
    1: dispatch
  } = useReducer(reducer, _objectSpread(_objectSpread({}, defaultInitialState), initialState));
  const router = useRouter();
  const step = useMemo(() => {
    var _router$query;
    const step = (_router$query = router.query) === null || _router$query === void 0 || (_router$query = _router$query.step) === null || _router$query === void 0 ? void 0 : _router$query.toString();
    if (!step) return 1;
    const matches = step.match(/^step(\d)$/);
    const stepNum = Number(matches[1]);
    if (stepNum <= options.maxStep) {
      return stepNum;
    } else {
      return 1;
    }
  }, [router.query, options.maxStep]);
  useEffect(() => {
    // ブラウザバック
    router.beforePopState(_ref => {
      let {
        as
      } = _ref;
      const match = as.match(/step(?<step>\d)/);
      const nextStep = (() => {
        const num = Number(match === null || match === void 0 ? void 0 : match.groups.step);
        if (isNaN(num)) return 1;
        return num;
      })();
      if (match) {
        // completeStepまでいったらブラウザバックさせない
        if (options.completeStep && state.nextStep === options.completeStep) {
          window.history.go(1);
          return false;
        }
        if (state.nextStep > nextStep) {
          dispatch({
            type: "prev"
          });
        } else if (state.nextStep < nextStep) {
          dispatch({
            type: "next"
          });
        } else if (state.nextStep === nextStep) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    });
    return () => {
      router.beforePopState(() => true);
    };
  }, [state.nextStep, options.completeStep]);
  return {
    step,
    state,
    dispatch
  };
}